import { CalendarSurfaceStore, SurfaceDragDropConfig } from 'owa-calendar-surface-dategrid';
import { action } from 'satcheljs/lib/legacy';
import { DragData } from 'owa-dnd/lib/utils/dragDataUtil';

/**
 * Called when the user drops a calendar item inside a valid droppable area
 * @surfaceStore The surface store
 */
export let dropCalendarItem = action('dropCalendarItem')(function dropCalendarItem(
    surfaceStore: CalendarSurfaceStore,
    dragDropConfig: SurfaceDragDropConfig,
    dragData: DragData
): void {
    let { dragDropState } = surfaceStore;

    // execute the drop action
    dragDropState.helperItemModel.ItemId.Id = dragDropState.draggedItemModel.ItemId.Id;
    let { onItemDropped } = dragDropConfig;
    if (onItemDropped) {
        onItemDropped(dragDropState.helperItemModel, dragDropState.draggedItemModel, dragData);
    }
});
